module.exports = __webpack_public_path__ + "static/img10-4f67ab5df1a0ddc8219ace6858772e30.jpg";